import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelySanofiMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="sanofiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#6C2E9C", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#9C27B0", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#E1BEE7", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#sanofiGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 16 }).map((_, ring) => {
          const nodeCount = 6 + ring * 2;
          const radius = 60 + ring * 25;
          return Array.from({ length: nodeCount }).map((_, n) => {
            const angle = (n / nodeCount) * 2 * Math.PI;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;
            return (
              <circle
                key={`molecule-${ring}-${n}`}
                cx={x}
                cy={y}
                r={12}
                fill="none"
                stroke="#FFFFFF"
                strokeWidth={1.5}
                opacity={0.3 - ring * 0.012}
              />
            );
          });
        })}
        {Array.from({ length: 14 }).map((_, c) => (
          <circle
            key={`bio-${c}`}
            cx={0}
            cy={0}
            r={(c + 1) * 28}
            fill="none"
            stroke="#9C27B0"
            strokeWidth={c % 3 === 0 ? 2.5 : 1.5}
            opacity={0.25 - c * 0.012}
          />
        ))}
        <circle cx={0} cy={0} r={50} fill="none" stroke="#FFFFFF" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={32} fill="#9C27B0" opacity={0.4} />
      </g>
    </svg>
  );
}
